// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

const getAppRecord = async (appRecordId: string) => {
  try {
    const recordRequest = await axios.get(
      `/api/shared/get-app-record/${appRecordId}`
    );
    const { data } = recordRequest;
    return data;
  } catch (error) {
    console.error("Utils - Get application record - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.GET_RECORD);
  }
};

export default getAppRecord;
